import React, { FC } from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { IconKebab } from '../icon/IconKebab';
import { IconButton, IconButtonSize } from '../input/IconButton';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Menu, MenuItem } from '../navigation/Menu';
import { Typography } from '../typography/Typography';
import { CollectionStatus, CollectionUI } from './types';

interface CollectionMenuProps {
    onRemove: VoidFunction;
    onEdit: VoidFunction;
    onShare: VoidFunction;
    onReport?: VoidFunction;
    onSave?: VoidFunction;
    onRemoveSaved?: VoidFunction;
    collection: CollectionUI;
    appMenuItem?: React.ReactElement;
    triggerSize?: IconButtonSize;
}

export const CollectionMenu: FC<CollectionMenuProps> = ({
    onEdit,
    onRemove,
    onShare,
    onSave,
    onRemoveSaved,
    collection,
    onReport,
    appMenuItem,
    triggerSize,
}) => {
    const t = useTranslation();

    return collection.modifiable ? (
        <Menu
            dataTestId={DataTestId.COLLECTION_MENU}
            trigger={
                <IconButton size={triggerSize} color="primary">
                    <IconKebab dataTestId={DataTestId.COLLECTION_KEBAB} />
                </IconButton>
            }
        >
            <MenuItem onClick={() => onEdit()}>
                <Typography noWrap dataTestId={DataTestId.EDIT_TEXT}>
                    {t('Редактировать')}
                </Typography>
            </MenuItem>
            {collection.isPublic && collection.status === CollectionStatus.PUBLISHED ? (
                <MenuItem onClick={onShare} dataTestId={DataTestId.SHARE}>
                    <Typography noWrap>{t('Поделиться')}</Typography>
                </MenuItem>
            ) : undefined}
            {collection.status === CollectionStatus.DECLINED ||
            collection.status === CollectionStatus.MODERATION ? (
                <MenuItem onClick={onShare}>
                    <Typography noWrap>{t('Статус коллекции')}</Typography>
                </MenuItem>
            ) : undefined}
            <MenuItem onClick={onRemove}>
                <Typography color="error" noWrap dataTestId={DataTestId.DELETE_TEXT}>
                    {t('Удалить')}
                </Typography>
            </MenuItem>
            {appMenuItem}
        </Menu>
    ) : (
        <Menu
            trigger={
                <IconButton size={triggerSize} color="primary">
                    <IconKebab dataTestId={DataTestId.COLLECTION_KEBAB} />
                </IconButton>
            }
        >
            <MenuItem onClick={onShare} dataTestId={DataTestId.SHARE}>
                <Typography noWrap>{t('Поделиться')}</Typography>
            </MenuItem>
            <MenuItem
                onClick={collection.isSaved ? onRemoveSaved : onSave}
                dataTestId={
                    collection.isSaved
                        ? DataTestId.REMOVE_SAVED_COLLECTION
                        : DataTestId.SAVE_COLLECTION
                }
            >
                <Typography noWrap>
                    {t(collection.isSaved ? 'Удалить из сохранённых' : 'Сохранить')}
                </Typography>
            </MenuItem>
            <MenuItem onClick={onReport}>
                <Typography noWrap color="error">
                    {t('Пожаловаться')}
                </Typography>
            </MenuItem>
            {appMenuItem}
        </Menu>
    );
};
